import React, { useRef, useState } from 'react';
import { Alert, Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import { withTranslation } from 'react-i18next';

export function ImportSiteModal({ importSite, open = false, showOpenButton = true, disabled, onBusyChange, t }) {
  const [isOpen, setOpen] = useState(open);
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const pending = useRef(false);
  function close() { if (!pending.current) { setOpen(false); setError(''); } }

  async function submit() {
    if (pending.current) return;
    try {
      const parsed = new URL(url.trim());
      if (!['http:', 'https:'].includes(parsed.protocol)) throw new Error();
    } catch { setError(t('template_import.invalid_url')); return; }
    pending.current = true;
    setBusy(true); setError(''); onBusyChange?.(true);
    try {
      await importSite(url.trim());
      setOpen(false);
    } catch (failure) {
      setError(failure.message || t('template_import.site_error'));
    } finally {
      pending.current = false; setBusy(false); onBusyChange?.(false);
    }
  }

  return <>
    {showOpenButton && <Button color="primary" outline className="mb-3" disabled={disabled}
      onClick={() => { setError(''); setOpen(true); }}>{t('landing_page.import_site')}</Button>}
    <Modal isOpen={isOpen} toggle={close} zIndex={1080} backdrop={busy ? 'static' : true}>
      <ModalHeader toggle={busy ? undefined : close}>{t('landing_page.import_site')}</ModalHeader>
      <ModalBody>
        <p>{t('template_import.site_help')}</p>
        {error && <Alert color="danger" role="alert">{error}</Alert>}
        <Label for="import-site-url">{t('landing_page.url')}</Label>
        <Input id="import-site-url" type="url" placeholder="https://example.com" value={url} disabled={busy}
          onChange={event => setUrl(event.target.value)} onKeyDown={event => {
            if (event.key === 'Enter') { event.preventDefault(); submit(); }
          }} />
      </ModalBody>
      <ModalFooter>
        <Button color="link" disabled={busy} onClick={close}>{t('landing_page.actions.cancel')}</Button>
        <Button color="primary" disabled={busy || !url.trim()} onClick={submit}>
          {busy && <Spinner tag="span" size="sm" className="mr-2" />}
          {t(busy ? 'template_import.importing' : 'landing_page.actions.import')}
        </Button>
      </ModalFooter>
    </Modal>
  </>;
}

export default withTranslation()(ImportSiteModal);
